export default "__VITE_ASSET__byCPYvSL__"